import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var base = {
  fontSize: "inherit",
  fontWeight: "inherit",
  textAlign: "inherit",
  bg: "transparent",
  transition: "all 0.2s",
  borderRadius: "md",
  paddingX: "3px",
  marginX: "-3px"
};
var Editable = {
  baseStyle: {
    Preview: _extends({}, base, {
      cursor: "text",
      display: "inline-block"
    }),
    Input: _extends({}, base, {
      outline: 0,
      width: "full",
      _focus: {
        boxShadow: "outline"
      },
      _placeholder: {
        opacity: 0.6
      }
    })
  }
};
export default Editable;